import { render } from "./AnnouncementView.vue?vue&type=template&id=3ec97de5&scoped=true"
import script from "./AnnouncementView.vue?vue&type=script&lang=js"
export * from "./AnnouncementView.vue?vue&type=script&lang=js"

import "./AnnouncementView.vue?vue&type=style&index=0&id=3ec97de5&scoped=true&lang=css"
import "./AnnouncementView.vue?vue&type=style&index=1&id=3ec97de5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec97de5"]])

export default __exports__